import React, { useEffect, useState } from 'react';
import axios from 'axios';
import publicIp from 'public-ip';
import qs from 'query-string';
import { Row, Col } from 'antd';

import LoginFactory from '../login/login.factory';
import { request } from '../../helpers/requests';
import analytics from '../../helpers/Analytics';
import loginSide from '../../assets/images/ontraccr-register-img.jpg';
import loginLogo from '../../assets/images/ontraccr-login-logo.png';
import LoginImageInfoContainer from '../login/LoginImageInfoContainer';
import GetStartedForm from './GetStartedForm';

export default ({
  history,
  search,
}) => {
  const [referrer,setReferrer] = useState();
  const [loading,setLoading] = useState(false);

  useEffect(()=>{
    (async () => {
      try {
        const ip = await publicIp.v4();
        fetch(`https://ipapi.co/${ip}/country/`)
        .then((response) => {
          return response.text();
        })
        .then((country) => {
          window.sessionStorage.setItem('countryCode', country);
        })
        .catch(() => {
          window.sessionStorage.setItem('countryCode', 'US');
        });
      } catch (error) {
        window.sessionStorage.setItem('countryCode', 'US');
      }

    })();
  },[])

  useEffect(() => {
    if(search) {
      const { source, referrer: qsReferrer } = qs.parse(search);
      setReferrer(qsReferrer);
      if(source) {
        analytics.track('GetStarted/RegisterPage',{ Source:source });
      }
    }
  },[search]);

  const onCreate = async ({
    companyName,
    firstName,
    lastName,
    username,
    email,
    password,
    companySize,
    companyTypes,
    industry,
    code,
    companyRegion,
  }) => {
    setLoading(true);
    const country = window.sessionStorage.getItem('countryCode') || 'US';
    const payload = {
      name:companyName,
      industry,
      companySize:parseInt(companySize),
      companyTypes,
      code,
      admin:{
        username,
        email,
        password,
        name: `${firstName} ${lastName}`,
      },
      country,
      referrer,
      region: companyRegion,
    };
    const { data } = await request({
      call:axios.post('/company',payload),
      successMsg:'Account Successfully Created!',
      errMsg:'Account Creation Failed. Company name and username must be unique.'
    });
    if(data) {
      analytics.track('GetStarted/AdminSignupComplete');
      const loggedIn = await LoginFactory.login(username,password);
      if (loggedIn) {
        history.push('/dashboard');
      }
    }

    setLoading(false);
  };

  return (
    <div className="login-page">
      <Row gutter={16} style={{ padding: 24, height: '100%' }}>
        <Col span={12} style={{ height: '100%' }}>
          <div
            className='login-container-redesign'
            style={{
              top: 0
            }}
          >
            <img alt="Ontraccr Logo" src={loginLogo} className="login-logo" />
            <GetStartedForm
              onCreate={onCreate}
              loading={loading}
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="login-side-image-container">
            <img alt="Ontraccr Side" src={loginSide} className="login-side-image" />
            <LoginImageInfoContainer />
          </div>
        </Col>
      </Row>
    </div>
  );
}
